import { QuestionTypeProps } from "../_types/type";

export default function ParagraphField({ index }: QuestionTypeProps) {
  return (
    <div className="mt-6 text-sm font-medium text-display-body">
      <div className="max-w-[500px] pb-2 border-b border-light mb-9">
        Long answer
      </div>
    </div>
  );
}
